import { useEffect, useState } from "react";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import { ButtonInput } from "../../components/shared/Inputs/ButtonInput";
import { PlusIcon } from "@heroicons/react/24/outline";
import EndSlateModal from "../../components/endSlateEditor/endSlateModal";
import { IPartImage } from './../../models/Part';
import useEndSlateImages from "../../data/useEndSlateImages";
import EndSlateTable from "../../components/endSlateEditor/endSlateTable";


export default function EndSlateEditor() {
  const { setInfo } = usePageNameContext();
  const { endSlateImages } = useEndSlateImages();
  const [open, setOpen] = useState(false);
  const [selectedEndSlate, setSelectedEndSlate] = useState<IPartImage | undefined>(undefined);

  const handleAddNewEndSlate = () => {
    setSelectedEndSlate(undefined);
    setOpen(true);
  };

  const handleSetEndSlate = (endSlate: IPartImage) => {
    setSelectedEndSlate(endSlate);
    setOpen(true);
  };

  useEffect(() => {
    setInfo({
      name: "End Slate Editor",
      desc: "Add Images to the end of all of your eBay listings",
    });
  }, [])

  return (
    <>
      <EndSlateModal open={open} setOpen={setOpen} endSlate={selectedEndSlate} />
      <div>
        <ButtonInput isSubmit={false} onClick={() => handleAddNewEndSlate()} classes={undefined}>
          <div className="flex items-center">
            <PlusIcon className="h-5 w-5 mr-2" />
            Add New End Slate
          </div>
        </ButtonInput>
      </div>

      <EndSlateTable endSlates={endSlateImages.data?.data ?? []} setSelectedBox={handleSetEndSlate} />
    </>
  )
}